import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from './StepNav.themes';
type Props = {
  activeStep?: number;
  ariaLabel?: string;
  className?: string;
  items: Array<{
    iconName: IconName;
    id: string;
    label: string;
  }>;
  lastActiveStep?: number;
  onClick: (step: number) => void;
  theme?: keyof typeof themes;
};
export const StepNav = ({
  activeStep = 0,
  ariaLabel = 'progress',
  className,
  items = [],
  lastActiveStep = 0,
  onClick,
  theme = 'default',
}: Props) => {
  if (!items.length) {
    return null;
  }

  const {
    thActiveNumber,
    thButtonLabel,
    thLabel,
    thLabels,
    thList,
    thListButton,
    thListButtonActive,
    thListButtonDisabled,
    thListButtonVisited,
    thListIconWidth,
    thListItem,
    thRoot,
  } = themes[theme];
  return (
    <nav
      aria-label={ariaLabel}
      className={classnames(thRoot, className)}
      data-testid="breadcrumb-steps"
    >
      <ol className={thList}>
        {items.map(({ iconName, id, label }, i) => (
          <li className={thListItem} key={id}>
            <button
              aria-current={activeStep === i ? 'step' : null}
              className={classnames(thListButton, {
                [thListButtonActive]: activeStep === i,
                [thListButtonVisited]: i <= lastActiveStep && activeStep !== i,
                [thListButtonDisabled]: i > lastActiveStep,
              })}
              disabled={i > lastActiveStep}
              onClick={() => onClick(i)}
              type="button"
            >
              <Icon name={iconName} width={thListIconWidth} />
              <span className={thButtonLabel}>{label}</span>
            </button>
          </li>
        ))}
      </ol>
      <p className={classnames(thLabels)}>
        <span className={thActiveNumber}>{activeStep + 1}</span>/{items.length}{' '}
        <span className={thLabel}>{items[activeStep].label}</span>
      </p>
    </nav>
  );
};
